import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import EmployeeLeaveModelPopup from "../../../components/modelpopup/EmployeeLeaveModelPopup";
import "../../../assets/css/employeeLeave.css";
import Holidays from "./Holidays";
import { companyID } from "../../../auth";
import { formatDecimal } from "../../../utils/formatDecimal";
import api from "../../../api/axios";
import BackButton from "../../../components/BackButton";
import { decrypt, encrypt } from "../../../utils/crypto";
import canTakeLeaveThisMonth from "../../../services/canTakeLeaveThisMonth";
import Loading from "../../../components/Loading";

function LeaveDashboard() {
  const loginEmployeeId = localStorage.getItem("employeeID");
  const [joiningDate, setJoiningDate] = useState(null);
  const encryptedEmployeeId = encrypt(loginEmployeeId);
  let { employee_id } = useParams();
  employee_id = decrypt(employee_id);
  const location = useLocation();
  const { employeeName = "" } = location.state || {};
  const [leaveType, setLeaveType] = useState([]);
  const [leaveBalance, setLeaveBalance] = useState([]);
  const [leave, setLeave] = useState({
    employee_id: "",
    start_date: "",
    end_date: "",
    leave_type: "",
    message: "",
    leave_reason: "",
    leave_days: "",
    leave_apply_period: "1",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleShow = () => setShow(!show);

  const mergedData = leaveType.map((leave) => {
    const balance =
      leaveBalance.find((b) => b.leave_type_id === leave.leave_id) || {};
    const monthlyTaken = leave?.monthly_allow_leaves != 0 ? canTakeLeaveThisMonth(leave?.monthly_allow_leaves, leave.total_days, joiningDate, balance?.leave_taken) : "-"
    return {
      name: leave?.leave_name,
      type: leave.leave_id,
      currentlyAvailable:
        balance.remaining_days !== undefined
          ? balance.remaining_days
          : leave.total_days || 0,
      credited:
        balance.carry_forward_days !== undefined
          ? balance.carry_forward_days
          : 0,
      utilized: balance?.leaves_taken_current_year || 0,
      annualAllotment: leave.total_days ? leave.total_days : balance?.total_leaves || 0,
      leave_taken: balance?.leave_taken || 0,
      monthly_allow_leaves: leave?.monthly_allow_leaves == 0 ? "-" : leave?.monthly_allow_leaves == 0 || '-',
      leaves_taken_current_year: balance?.leaves_taken_current_year || 0,
      leaves_taken_current_month: balance?.leaves_taken_current_month || 0,
      monthly_credited_leave: monthlyTaken?.leave || '-'

    };
  });

  useEffect(() => {
    if (isModalOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    // Cleanup on component unmount
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isModalOpen]);

  useEffect(() => {
    const company_id = companyID();
    setLoading(true);

    Promise.all([
      api.get(`leaveTypes/${company_id}`),
      api.get(`employee-joining-date?employee_id=${employee_id}`),
      api.get(`leaveBalance/${employee_id}`)
    ])
      .then(([leaveTypesRes, joiningDateRes, leaveBalanceRes]) => {
        setLeaveType(leaveTypesRes.data);
        setJoiningDate(joiningDateRes.data?.result[0]?.joining_date);
        setLeaveBalance(leaveBalanceRes.data);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [employee_id]);

  const navigate = useNavigate();
  const formatLeave = (num) => {
    if (num == NaN) return 0;
    if (num === 0 || num === 0.0) return 0;
    return parseFloat(num); // removes unnecessary trailing zeros
  };

  if (loading) {
    return <Loading size="xl" variant="dots" text="" />;
  }

  return (
    <>
      <div className="main-wrapper leave-dashboard">
        <div className="page-wrapper">
          <div className="content container-fluid position-relative">
            <Row className="mb-4 mt-3">
              <Col className="d-flex align-items-center">
                <h4>
                  {show ? "Holidays" : `${employeeName} Time Off Balance`}
                </h4>
              </Col>
              {loginEmployeeId === employee_id && (
                <Col className="d-flex justify-content-end align-items-center gap-2">
                  <Button
                    variant="outline-primary"
                    className="mr-2"
                    onClick={() => {
                      handleShow();
                    }}
                  >
                    {show ? "Leave Dashboard" : "List of Holidays"}
                  </Button>

                  <Button
                    variant="outline-success"
                    onClick={() =>
                      navigate(`../leaves-employee/${encryptedEmployeeId}`, {
                        state: {
                          modalOpen: true,
                        },
                      })
                    }
                  >
                    Apply Leave
                  </Button>
                </Col>
              )}
              <div className="position-relative w-100 m-2">
                <BackButton position={{ right: "4px" }} />
              </div>
            </Row>
            {!show && (
              <Row>
                {mergedData.map((leave, index) => (
                  <Col md={4} className="mb-4" key={index}>
                    <Card>
                      <Card.Body>
                        <Card.Title>{leave?.name}</Card.Title>
                        <Card.Text>
                          {leave?.name != "Unpaid Leave" ? (
                            <>
                              <>
                                <h3>
                                  {formatDecimal(leave?.currentlyAvailable)}
                                </h3>
                                <p>Currently Available</p>
                              </>

                              <div className="table-responsive">
                                <table className="table borderless-table">
                                  <thead className="table-light">
                                    <tr>
                                      <th></th>
                                      <th>Year</th>
                                      <th>This Month</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="text-start">Credited From last</td>
                                      <td>{Number(leave?.credited) ? formatLeave(leave?.credited) : 0}</td>
                                      <td>{Number(leave?.monthly_credited_leave) ? formatLeave(leave?.monthly_credited_leave) : "-"}</td>
                                    </tr>
                                    <tr>
                                      <td className="text-start">Utilized</td>
                                      <td>{leave?.utilized !== undefined ? formatLeave(leave?.utilized) : formatLeave(leave?.leaves_taken_current_year) || 0}</td>
                                      <td>{Number(leave?.leaves_taken_current_month) ? formatLeave(leave?.leaves_taken_current_month) : "0"}</td>
                                    </tr>
                                    <tr>
                                      <td className="text-start">Allotment</td>
                                      <td>{leave?.annualAllotment ? formatLeave(leave?.annualAllotment) : 0}</td>
                                      <td>{Number(leave?.monthly_allow_leaves) ? formatLeave(leave?.monthly_allow_leaves) : "-"}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </>

                          ) : (
                            <>
                              <h3>
                                {formatDecimal(leave?.leave_taken)}
                              </h3>
                              <p>Currently Taken</p>

                              <div className="table-responsive">
                                <table className="table borderless-table">
                                  <thead className="table-light">
                                    <tr>
                                      <th></th>
                                      <th>Year</th>
                                      <th>This Month</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="text-start">Leave Taken </td>
                                      <td> {formatLeave(leave?.leave_taken)}</td>

                                      <td>{Number(leave?.leaves_taken_current_month) ? formatLeave(leave?.leaves_taken_current_month) : "0"}</td>

                                    </tr>

                                  </tbody>
                                </table>
                              </div>
                            </>
                          )}

                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            )}

            {/* <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>Modal title</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Holidays />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary">Understood</Button>
            </Modal.Footer>
          </Modal> */}
            {show && <Holidays />}
          </div>
        </div>
        {isModalOpen && <div className="modal-backdrop fade show"></div>}
      </div>

      {/* <EmployeeLeaveModelPopup /> */}
      <EmployeeLeaveModelPopup
        leave={leave}
        setLeave={setLeave}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
}

export default LeaveDashboard;
